import { render } from "./IntersectionObserver.vue?vue&type=template&id=0143691e"
import script from "./IntersectionObserver.vue?vue&type=script&lang=ts"
export * from "./IntersectionObserver.vue?vue&type=script&lang=ts"
script.render = render

export default script